import type { ViewIds } from '@ardoq/api-types';
import {
  canBypassViewDataLimit,
  isAboveViewDataLimit,
} from 'views/environmentals/viewDataLimits';

type GraphItemLimitArgs = {
  viewId: ViewIds;
  nodeCount: number;
  edgeCount: number;
  presentationMode: boolean;
};

export const isAboveItemLimit = ({
  viewId,
  nodeCount,
  edgeCount,
  presentationMode,
}: GraphItemLimitArgs): boolean =>
  !presentationMode && isAboveViewDataLimit(viewId, nodeCount + edgeCount);

export const canBypassLimit = ({
  viewId,
  nodeCount,
  edgeCount,
  presentationMode,
}: GraphItemLimitArgs): boolean =>
  !presentationMode && canBypassViewDataLimit(viewId, nodeCount + edgeCount);
